import { render, staticRenderFns } from "./formApprovalRequest.vue?vue&type=template&id=8fa2736c&scoped=true&lang=pug&"
import script from "./formApprovalRequest.vue?vue&type=script&lang=js&"
export * from "./formApprovalRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fa2736c",
  null
  
)

export default component.exports